<dojo-master-list-view
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [agGridAdditionalClass]="'small-height'"
  [canAdd]="false"
  [showToolbarAddButton]="false"
  (gridRowClicked)="openQuestion($event)"
  [hideSearch]="true"
  (gridReady)="onGridReady($event)"
  [@appearOnTrigger]="!isLoading()"
/>

@if (isLoading()) {
  <div class="absolute left-0 top-0 flex h-full w-full items-center justify-center">
    <dojo-loader />
  </div>
}
